module.exports = __webpack_public_path__ + "img/play-spotify2.5e1f2261.svg";